export const environment = {
  production: true,
  baseUrl: 'https://simy.hu',
  extUrl: '/assets/landing/'
};
